import React from 'react';
import cn from 'classnames';
import wholeProcess from '@/asserts/images/advantage/icon-whole-process.svg';
import improve from '@/asserts/images/advantage/icon-improve.svg';
import cooperation from '@/asserts/images/advantage/icon-cooperation.svg';
import ai from '@/asserts/images/advantage/icon-ai.svg';
import automation from '@/asserts/images/advantage/icon-automation.svg';
import extensible from '@/asserts/images/advantage/icon-extensible.svg';
import { getSite, PLATFORM } from '@/common/constants/platform-constants';
import s from './index.module.less';

const cards = [
  {
    key: 'wholeProcess',
    title: '全面的 API 生命周期管理',
    desc: '基于统一 的 proto 管理及桩代码生成，保证研发及依赖管理规范性；借助 HTTP、tRPC 等多协议在线调试、接口 Mock、接口用例等应用场景，提升 API 开发及自测效率。',
    icon: wholeProcess,
  },
  {
    key: 'improve',
    title: '高效服务研发过程',
    desc: '支持配置 Mock 环境及规则，定制化协议文件模版，Proto规范性检查，接口鉴权，代码生成以及本地IDE插件工具等，助力研发全方位提效。',
    icon: improve,
  },
  {
    key: 'automation',
    title: '低门槛的自动化测试',
    desc: getSite() === PLATFORM.STANDALONE_WOA ? '通过低代码图形化方式，轻松组装场景用例可用性监控的拨测任务和定时测试任务，支持高效的数据驱动、可视化执行报告以及多维度监控告警。' : '通过低代码图形化方式，轻松组装接口场景用例和任务，降低自动化测试建设门槛；高效的数据驱动测试模式提升覆盖率，和可视化的任务报告及触达能力。',
    icon: automation,
  },
  {
    key: 'cooperation',
    title: '高效的团队协同分享',
    desc: '通过最真实的协议定义，自动生成接口文档，降低文档组织成本；支持设置公开文档，方便项目外成员共享接口文档，并支持公开文档自定义结构，全文搜索等。',
    icon: cooperation,
  },
  {
    key: 'ai',
    title: 'AI 生成式解放双手',
    desc: '探索 API 全生命周期平台未来工作形态，结合生成式大模型能力，提供各种一键能力。',
    icon: ai,
  },
  {
    key: 'extensible',
    title: '高可扩展性',
    desc: '支持自定义脚本，自定义节点，runtime 与脚本语言，PubSub & ServiceHook，代码生成工具扩展和自定义协议扩展。',
    icon: extensible,
  },
];

const Advantage = () => (
  <div className={s.cards}>
    {
      cards.map(item => (
        <div key={item.key} className={cn(s.card)}>
          <img src={item.icon} className={s.cIcon} alt="" />
          <div className={s.subTitle}>{item.title}</div>
          <div className={s.desc}>{item.desc}</div>
        </div>
      ))
    }
  </div>
);

export default Advantage;
